import { STOCK_TEMPLATE_KEYS } from 'modules/hatch/pages/competitors/constants';

export const WIDGET_MAX_SMART_ANSWERS = 5;
/** The widget's supported card types, independent of additions to the app catalogue. */
export const WIDGET_BATTLECARD_TEMPLATE_KEYS = [
  STOCK_TEMPLATE_KEYS.COMPETITOR_OVERVIEW,
  STOCK_TEMPLATE_KEYS.DIFFERENTIATION,
  STOCK_TEMPLATE_KEYS.HOW_WE_WIN,
  STOCK_TEMPLATE_KEYS.VULNERABILITIES,
  STOCK_TEMPLATE_KEYS.PRICING_COMPARISON,
  STOCK_TEMPLATE_KEYS.DISCOVERY_QUESTIONS,
  STOCK_TEMPLATE_KEYS.OBJECTION_HANDLING,
  STOCK_TEMPLATE_KEYS.PROOF_POINTS,
] as const;
export const WIDGET_MAX_STOCK_ANSWERS = WIDGET_BATTLECARD_TEMPLATE_KEYS.length;
export const SFDC_WIDGET_CONTENT_MAX_HEIGHT = 290;

export const KLUE_APP_BASE_URL =
  import.meta.env.VITE_KLUE_V2_APP_URL || 'https://v2.app.klue.com';

export const SFDC_EMBED_ROUTE = '/sfdc-embed/deal-tips';

export const SFDC_LWC_WIDGET_ROUTE = '/sfdc/widget';

// Caps for the inner ScrollAreas. The widget is rendered in a parent-sized
// iframe (Salesforce Canvas via the Rails embed, or the LWC widget). The
// embed posts the document's natural height back to the parent via
// useIframeResize; these caps prevent very long competitor / answer lists
// from making the iframe grow without bound. Heights below this stay
// natural so the iframe shrinks to fit short content.
export const SFDC_WIDGET_SCROLL_MAX_HEIGHT = 280;
